module.exports = __webpack_public_path__ + "static/image-54244732fa111cb01f21aab2470ab55b.jpg";